import BWAccordion from 'components/shared/BWAccordion/index';
import React, { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { notification } from 'antd';
import styled from 'styled-components';
import ErrorMessage from 'components/shared/BWFormControl/ErrorMessage';

const DivFile = styled.div`
  padding: 0px 15px;
  display: inline-flex;
  align-items: center;
  border-radius: 5px;
  background: var(--grayColor);
  color: var(--mainColor);
  font-weight: 600;
  cursor: pointer;
`;

const SpanFile = styled.span`
  line-height: 40px;
  max-width: 160px;
  width: 160px;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
`;

const FileAttachment = ({ disabled }) => {
  const methods = useFormContext();
  const {
    watch,
    getValues,
    setValue,
    formState: { errors },
  } = methods;


    const uploadFiles = (e) => {
        const files = e.target.files;

        for (let i = 0; i < Object.keys(files).length; i++) {
            if (files[i].name.match(/\.(jpg|png)$/i)) {
                // Create object URL for image preview if needed
                URL.createObjectURL(files[i]);
            }
        }

        methods.setValue('file_list', [...(methods.watch('file_list') ?? []), ...files]);
    };

    const handleRemoveFile = (idx) => {
        const files = getValues('file_list');
        setValue(
            'file_list',
            files.filter((_, i) => i !== idx),
        );
    };

  const handleDownloadFile = async (item) => {
    try {
      if (item instanceof File) {
        // Nếu là File object (file mới upload)
        const url = window.URL.createObjectURL(item);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', item.name);
        document.body.appendChild(link);
        link.click();
        window.URL.revokeObjectURL(url);
      } else if (item.file_path) {
        // Nếu là dữ liệu từ server (có file_path)
        const link = document.createElement('a');
        link.href = item.file_path;
        link.setAttribute('download', item.file_name || item.file_path.split('/').pop());
        link.setAttribute('target', '_blank');
        document.body.appendChild(link);
        link.click();
      }
    } catch (error) {
      notification.error({ message: error.message || 'Lỗi tải tập tin.' });
    }
  };

    useEffect(() => {
        methods.register('file_list', {
            validate: (v) => {
                if (!Array.isArray(v) || v.length <= 0) {
                    return 'File là bắt buộc';
                }
                return true;
            },
        });
    }, [methods]);

    return (
        <BWAccordion title="CV đính kèm" id="bw_hs">
            <div className="bw_mt_1 bw_flex bw_align_items_center">
                {!disabled ? (
                    <label className="bw_choose_image_banner">
                        <input
                            type="file"
                            multiple
                            accept="file_extension|audio/*|video/*|image/*|media_type"
                            onChange={uploadFiles}
                        />
                        <span className="fi fi-rr-add"></span>
                    </label>
                ) : null}

                {(watch('file_list') ?? [])?.map((item, i) => (
                    <div
                        className="bw_card_items bw_green"
                        key={i}
                        style={{ padding: ' 15px 20px', alignSelf: 'flex-start', margin: '0 10px 10px 0' }}
                    >
            {item instanceof File ? (
              <DivFile>
                <SpanFile>{item.name}</SpanFile>
              </DivFile>
            ) : (
              <DivFile onClick={() => handleDownloadFile(item)}>
                <SpanFile>{item.file_name || item.file_path?.split('/').pop() || 'File'}</SpanFile>
              </DivFile>
            )}

                        {!disabled ? (
                            <span className="bw_remove_image bw_red" onClick={() => handleRemoveFile(i)}>
                                <i className="fi fi-rr-trash"></i>
                            </span>
                        ) : null}
                    </div>
                ))}
            </div>

            {errors['file_list'] && <ErrorMessage message={errors['file_list']?.message} />}
        </BWAccordion>
    );
};

export default FileAttachment;
